import store from '@/store'
export default {
  // 半成品车间检索
  className: 'shopManagement',
  fields: [
    'name',
    'parentNode'
  ],
  hooks: {
    beforeFetch ({ where }) {
      where.type = {
        $in: ['workShop', 'model']
      }
      if (store.state.user.allShopManagements === 'Yes') { } else {
        where.workShop = {
          $in: store.state.user.shopManagements
        }
      }
      // if (store.state.user.adminRole === 'workshop') {
      // where.workShop = store.state.user.workShop
      // where.workShop = {
      //   $in: store.state.user.shopManagements
      // }
      // }
    }
  }
}
